import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ISO8601DateTime: any;
  JSON: any;
};

export type ColumnSchema = {
  __typename?: 'ColumnSchema';
  /** カラムの内容を説明する文言 */
  description?: Maybe<Scalars['String']>;
  /** カラムを表示する際の名称 */
  displayName?: Maybe<Scalars['String']>;
  /** カラムの表示幅 */
  displayWidth?: Maybe<Scalars['Int']>;
  /** 表示する際のフォーマット */
  format?: Maybe<Scalars['String']>;
  /** カラム名 */
  name: Scalars['String'];
  /** 参照するテーブル */
  ref?: Maybe<Scalars['String']>;
  /** 参照先データを表示する際に代表となるカラム名 */
  refDisplay?: Maybe<Scalars['String']>;
  /** 必須かどうか */
  required?: Maybe<Scalars['Boolean']>;
  /** カラムの並び順 */
  sortIndex?: Maybe<Scalars['Int']>;
  /** データ型 */
  type: ColumnTypeEnum;
};

export type ColumnSchemaExtensionInput = {
  /** カラムの内容を説明する文言 */
  description?: InputMaybe<Scalars['String']>;
  /** カラムを表示する際の名称 */
  displayName?: InputMaybe<Scalars['String']>;
  /** カラムの表示幅 */
  displayWidth?: InputMaybe<Scalars['Int']>;
  /** カラム名 */
  name: Scalars['String'];
  /** 参照先データを表示する際に代表となるカラム名 */
  refDisplay?: InputMaybe<Scalars['String']>;
  /** カラムの並び順 */
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export enum ColumnTypeEnum {
  /** 日時 */
  Datetime = 'datetime',
  /** 順列がある複数データ。要素の型は任意 */
  List = 'list',
  /** 数値 */
  Number = 'number',
  /** 曜日を軸にした繰り返し */
  Repetition = 'repetition',
  /** 文字列 */
  String = 'string',
  /** 日時範囲 */
  TimePeriod = 'time_period'
}

/** Autogenerated input type of CreateMasterRecord */
export type CreateMasterRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** テーブル名 */
  tableName: Scalars['String'];
};

/** Autogenerated return type of CreateMasterRecord */
export type CreateMasterRecordPayload = {
  __typename?: 'CreateMasterRecordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** レコード情報 */
  masterRecord: MasterRecord;
};

/** Autogenerated input type of CreateMasterRecordsCsv */
export type CreateMasterRecordsCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Data URI 形式の csv データ */
  dataUri: Scalars['String'];
  /** オリジナルのファイル名 */
  fileName: Scalars['String'];
  /** テーブル名 */
  tableName: Scalars['String'];
};

/** Autogenerated return type of CreateMasterRecordsCsv */
export type CreateMasterRecordsCsvPayload = {
  __typename?: 'CreateMasterRecordsCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 重複削除されたレコードのID */
  duplicateRecordIds: Array<Scalars['String']>;
  /** 追加されたレコード */
  records: Array<MasterRecord>;
};

/** Autogenerated input type of DeleteMasterRecord */
export type DeleteMasterRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** レコードID */
  recordId: Scalars['String'];
};

/** Autogenerated return type of DeleteMasterRecord */
export type DeleteMasterRecordPayload = {
  __typename?: 'DeleteMasterRecordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 結果 */
  result: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteMasterTableData */
export type DeleteMasterTableDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** テーブル名 */
  tableName: Scalars['String'];
};

/** Autogenerated return type of DeleteMasterTableData */
export type DeleteMasterTableDataPayload = {
  __typename?: 'DeleteMasterTableDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 結果 */
  result: Scalars['Boolean'];
};

/** Autogenerated input type of FinalizeMasterRecord */
export type FinalizeMasterRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** レコードID */
  recordId: Scalars['String'];
};

/** Autogenerated return type of FinalizeMasterRecord */
export type FinalizeMasterRecordPayload = {
  __typename?: 'FinalizeMasterRecordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** エラー情報 */
  errors?: Maybe<Array<MasterRecordValidationError>>;
  /** 結果 */
  result: Scalars['Boolean'];
};

/** Autogenerated input type of FinalizeMasterTable */
export type FinalizeMasterTableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** テーブル名 */
  tableName: Scalars['String'];
};

/** Autogenerated return type of FinalizeMasterTable */
export type FinalizeMasterTablePayload = {
  __typename?: 'FinalizeMasterTablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** エラー情報 */
  errors?: Maybe<Array<MasterRecordValidationError>>;
  /** 確定されたレコードID */
  recordIds?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of Logout */
export type LogoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of Logout */
export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 成功 */
  success: Scalars['Boolean'];
};

export type MasterRecord = {
  __typename?: 'MasterRecord';
  /** カラム名と値 */
  columns?: Maybe<Scalars['JSON']>;
  /** レコード作成日 */
  createdAt: Scalars['ISO8601DateTime'];
  /** レコードID */
  id: Scalars['ID'];
  /** 登録状態 */
  stage: MasterRecordStage;
  /** レコード更新日 */
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum MasterRecordStage {
  /** 確定済み状態 */
  Final = 'final',
  /** 仮登録状態 */
  Temporary = 'temporary'
}

export type MasterRecordValidationError = {
  __typename?: 'MasterRecordValidationError';
  /** カラム名 */
  columnName: Scalars['String'];
  /** エラー名のリスト */
  errors: Array<Scalars['String']>;
  /** レコードID */
  recordId: Scalars['String'];
};

export type MasterSchema = {
  __typename?: 'MasterSchema';
  /** service manager で表示するかどうか */
  allowSmEdit: Scalars['Boolean'];
  /** Service Manager でテーブルの一括データ削除を有効するかどうか */
  allowSmDelete: Scalars['Boolean']
  /** csv による登録を許可するかどうか */
  allowUpload: Scalars['Boolean'];
  /** 各カラムの情報 */
  columns: Array<ColumnSchema>;
  /** 主キーのカラム名 */
  primaryKey: Scalars['String'];
  /** テーブル名 */
  tableName: Scalars['String'];
};

export type MasterTableCsv = {
  __typename?: 'MasterTableCsv';
  /** Base64形式の CSV データ */
  data?: Maybe<Scalars['String']>;
  /** ファイル名 */
  filename: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** 指定したテーブルに新しいレコードを追加する */
  createMasterRecord: CreateMasterRecordPayload;
  /** 指定したテーブルに複数のレコードを追加する（csv を使用） */
  createMasterRecordsCsv: CreateMasterRecordsCsvPayload;
  /** 指定したレコードを削除する */
  deleteMasterRecord: DeleteMasterRecordPayload;
  /** 指定したテーブルの全てのレコードを削除 */
  deleteMasterTableData: DeleteMasterTableDataPayload;
  /** 指定したレコードを確定する */
  finalizeMasterRecord: FinalizeMasterRecordPayload;
  /** 指定したテーブルの未確定のレコードを全て確定する */
  finalizeMasterTable: FinalizeMasterTablePayload;
  /** ログアウトする */
  logout: LogoutPayload;
  /** 指定したテーブルの未確定のレコードを全て削除する */
  rejectMasterTable: RejectMasterTablePayload;
  /** 指定したレコードを更新する */
  updateMasterRecord: UpdateMasterRecordPayload;
  /** 指定したテーブルの設定を変更する */
  updateMasterSchema: UpdateMasterSchemaPayload;
};


export type MutationCreateMasterRecordArgs = {
  input: CreateMasterRecordInput;
};


export type MutationCreateMasterRecordsCsvArgs = {
  input: CreateMasterRecordsCsvInput;
};


export type MutationDeleteMasterRecordArgs = {
  input: DeleteMasterRecordInput;
};


export type MutationDeleteMasterTableDataArgs = {
  input: DeleteMasterTableDataInput;
};


export type MutationFinalizeMasterRecordArgs = {
  input: FinalizeMasterRecordInput;
};


export type MutationFinalizeMasterTableArgs = {
  input: FinalizeMasterTableInput;
};


export type MutationLogoutArgs = {
  input: LogoutInput;
};


export type MutationRejectMasterTableArgs = {
  input: RejectMasterTableInput;
};


export type MutationUpdateMasterRecordArgs = {
  input: UpdateMasterRecordInput;
};


export type MutationUpdateMasterSchemaArgs = {
  input: UpdateMasterSchemaInput;
};

export type Query = {
  __typename?: 'Query';
  /** 指定したテーブルのレコードを全て取得する */
  masterRecords: Array<MasterRecord>;
  /** マスターデータの定義を取得する */
  masterSchema: Array<MasterSchema>;
  /** 指定したテーブルのレコードを CSV 形式で取得する */
  masterTableCsv: MasterTableCsv;
  /** Userの情報を取得する */
  user: User;
};


export type QueryMasterRecordsArgs = {
  tableName: Scalars['String'];
};


export type QueryMasterTableCsvArgs = {
  tableName: Scalars['String'];
};

/** Autogenerated input type of RejectMasterTable */
export type RejectMasterTableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** テーブル名 */
  tableName: Scalars['String'];
};

/** Autogenerated return type of RejectMasterTable */
export type RejectMasterTablePayload = {
  __typename?: 'RejectMasterTablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 削除されたレコードID */
  recordIds: Array<Scalars['String']>;
};

/** Autogenerated input type of UpdateMasterRecord */
export type UpdateMasterRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 更新する値 */
  columnData: Scalars['JSON'];
  /** 更新対象のカラム名 */
  columnName: Scalars['String'];
  /** 更新対象のレコードID */
  recordId: Scalars['String'];
};

/** Autogenerated return type of UpdateMasterRecord */
export type UpdateMasterRecordPayload = {
  __typename?: 'UpdateMasterRecordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** エラー名のリスト */
  errors?: Maybe<Array<Scalars['String']>>;
  /** 結果 */
  result: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateMasterSchema */
export type UpdateMasterSchemaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 対象のカラムの設定内容 */
  columns: Array<ColumnSchemaExtensionInput>;
  /** 対象のテーブル名 */
  tableName: Scalars['String'];
};

/** Autogenerated return type of UpdateMasterSchema */
export type UpdateMasterSchemaPayload = {
  __typename?: 'UpdateMasterSchemaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 結果 */
  result: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  /** 権限 */
  authority: Scalars['Int'];
  /** eメール */
  email?: Maybe<Scalars['String']>;
  /** ユーザーID */
  id: Scalars['ID'];
  /** 画像url */
  imageUrl?: Maybe<Scalars['String']>;
  /** 有効かどうか */
  isActive: Scalars['Boolean'];
  /** 社内メンバーかどうか */
  isInternalMember: Scalars['Boolean'];
  /** 二要素認証済みかどうか */
  isTfaRegistered: Scalars['Boolean'];
  /** 名前 */
  name?: Maybe<Scalars['String']>;
  /** オフィスID */
  officeId?: Maybe<Scalars['ID']>;
  /** タイムゾーン */
  timezone?: Maybe<Scalars['String']>;
};

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, name?: string | null | undefined, email?: string | null | undefined, imageUrl?: string | null | undefined, authority: number, timezone?: string | null | undefined, isInternalMember: boolean, isActive: boolean, officeId?: string | null | undefined, isTfaRegistered: boolean } };

export type MasterTableCsvQueryVariables = Exact<{
  tableName: Scalars['String'];
}>;


export type MasterTableCsvQuery = { __typename?: 'Query', masterTableCsv: { __typename?: 'MasterTableCsv', filename: string, data?: string | null | undefined } };

export type UpdateMasterRecordMutationVariables = Exact<{
  recordId: Scalars['String'];
  columnName: Scalars['String'];
  columnData: Scalars['JSON'];
}>;


export type UpdateMasterRecordMutation = { __typename?: 'Mutation', updateMasterRecord: { __typename?: 'UpdateMasterRecordPayload', errors?: Array<string> | null | undefined } };

export type MasterRecordsQueryVariables = Exact<{
  tableName: Scalars['String'];
}>;


export type MasterRecordsQuery = { __typename?: 'Query', masterRecords: Array<{ __typename?: 'MasterRecord', id: string, columns?: any | null | undefined, stage: MasterRecordStage }> };

export type CreateMasterRecordMutationVariables = Exact<{
  tableName: Scalars['String'];
}>;


export type CreateMasterRecordMutation = { __typename?: 'Mutation', createMasterRecord: { __typename?: 'CreateMasterRecordPayload', masterRecord: { __typename?: 'MasterRecord', id: string, columns?: any | null | undefined, stage: MasterRecordStage } } };

export type DeleteMasterRecordMutationVariables = Exact<{
  recordId: Scalars['String'];
}>;

export type DeleteMasterTableDataMutationVariables = Exact<{
  tableName: Scalars['String'];
}>;


export type DeleteMasterRecordMutation = { __typename?: 'Mutation', deleteMasterRecord: { __typename?: 'DeleteMasterRecordPayload', result: boolean } };

export type DeleteMasterTableDataMutation = { __typename?: 'Mutation', deleteMasterTableData: { __typename?: 'DeleteMasterTableDataPayload', result: boolean } };

export type FinalizeMasterRecordMutationVariables = Exact<{
  recordId: Scalars['String'];
}>;


export type FinalizeMasterRecordMutation = { __typename?: 'Mutation', finalizeMasterRecord: { __typename?: 'FinalizeMasterRecordPayload', result: boolean, errors?: Array<{ __typename?: 'MasterRecordValidationError', recordId: string, columnName: string, errors: Array<string> }> | null | undefined } };

export type CreateMasterRecordsCsvMutationVariables = Exact<{
  tableName: Scalars['String'];
  dataUri: Scalars['String'];
  fileName: Scalars['String'];
}>;


export type CreateMasterRecordsCsvMutation = { __typename?: 'Mutation', createMasterRecordsCsv: { __typename?: 'CreateMasterRecordsCsvPayload', duplicateRecordIds: Array<string>, records: Array<{ __typename?: 'MasterRecord', id: string, columns?: any | null | undefined, stage: MasterRecordStage }> } };

export type MasterSchemaQueryVariables = Exact<{ [key: string]: never; }>;


export type MasterSchemaQuery = { __typename?: 'Query', masterSchema: Array<{ __typename?: 'MasterSchema', tableName: string, primaryKey: string, allowUpload: boolean, allowSmEdit: boolean, allowSmDelete: boolean, columns: Array<{ __typename?: 'ColumnSchema', name: string, type: ColumnTypeEnum, format?: string | null | undefined, ref?: string | null | undefined, required?: boolean | null | undefined, refDisplay?: string | null | undefined, displayName?: string | null | undefined, description?: string | null | undefined, sortIndex?: number | null | undefined, displayWidth?: number | null | undefined }> }> };

export type UpdateMasterSchemaMutationVariables = Exact<{
  tableName: Scalars['String'];
  columns: Array<ColumnSchemaExtensionInput> | ColumnSchemaExtensionInput;
}>;


export type UpdateMasterSchemaMutation = { __typename?: 'Mutation', updateMasterSchema: { __typename?: 'UpdateMasterSchemaPayload', result: boolean } };

export type FinalizeMasterTableMutationVariables = Exact<{
  tableName: Scalars['String'];
}>;


export type FinalizeMasterTableMutation = { __typename?: 'Mutation', finalizeMasterTable: { __typename?: 'FinalizeMasterTablePayload', recordIds?: Array<string> | null | undefined, errors?: Array<{ __typename?: 'MasterRecordValidationError', recordId: string, columnName: string, errors: Array<string> }> | null | undefined } };

export type RejectMasterTableMutationVariables = Exact<{
  tableName: Scalars['String'];
}>;


export type RejectMasterTableMutation = { __typename?: 'Mutation', rejectMasterTable: { __typename?: 'RejectMasterTablePayload', recordIds: Array<string> } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutPayload', success: boolean } };


export const UserDocument = gql`
    query user {
  user {
    id
    name
    email
    imageUrl
    authority
    timezone
    isInternalMember
    isActive
    officeId
    isTfaRegistered
  }
}
    `;
export const MasterTableCsvDocument = gql`
    query masterTableCsv($tableName: String!) {
  masterTableCsv(tableName: $tableName) {
    filename
    data
  }
}
    `;
export const UpdateMasterRecordDocument = gql`
    mutation updateMasterRecord($recordId: String!, $columnName: String!, $columnData: JSON!) {
  updateMasterRecord(
    input: {recordId: $recordId, columnName: $columnName, columnData: $columnData}
  ) {
    errors
  }
}
    `;
export const MasterRecordsDocument = gql`
    query masterRecords($tableName: String!) {
  masterRecords(tableName: $tableName) {
    id
    columns
    stage
  }
}
    `;
export const CreateMasterRecordDocument = gql`
    mutation createMasterRecord($tableName: String!) {
  createMasterRecord(input: {tableName: $tableName}) {
    masterRecord {
      id
      columns
      stage
    }
  }
}
    `;
export const DeleteMasterRecordDocument = gql`
    mutation deleteMasterRecord($recordId: String!) {
  deleteMasterRecord(input: {recordId: $recordId}) {
    result
  }
}
    `;
export const DeleteMasterTableDataDocument = gql`
    mutation deleteMasterTableData($tableName: String!) {
  deleteMasterTableData(input: {tableName: $tableName}) {
    result
  }
}
    `;
export const FinalizeMasterRecordDocument = gql`
    mutation finalizeMasterRecord($recordId: String!) {
  finalizeMasterRecord(input: {recordId: $recordId}) {
    result
    errors {
      recordId
      columnName
      errors
    }
  }
}
    `;
export const CreateMasterRecordsCsvDocument = gql`
    mutation createMasterRecordsCsv($tableName: String!, $dataUri: String!, $fileName: String!) {
  createMasterRecordsCsv(
    input: {tableName: $tableName, dataUri: $dataUri, fileName: $fileName}
  ) {
    records {
      id
      columns
      stage
    }
    duplicateRecordIds
  }
}
    `;
export const MasterSchemaDocument = gql`
    query masterSchema {
  masterSchema {
    tableName
    columns {
      name
      type
      format
      ref
      required
      refDisplay
      displayName
      description
      sortIndex
      displayWidth
    }
    primaryKey
    allowUpload
    allowSmEdit
    allowSmDelete
  }
}
    `;
export const UpdateMasterSchemaDocument = gql`
    mutation updateMasterSchema($tableName: String!, $columns: [ColumnSchemaExtensionInput!]!) {
  updateMasterSchema(input: {tableName: $tableName, columns: $columns}) {
    result
  }
}
    `;
export const FinalizeMasterTableDocument = gql`
    mutation finalizeMasterTable($tableName: String!) {
  finalizeMasterTable(input: {tableName: $tableName}) {
    recordIds
    errors {
      recordId
      columnName
      errors
    }
  }
}
    `;
export const RejectMasterTableDocument = gql`
    mutation rejectMasterTable($tableName: String!) {
  rejectMasterTable(input: {tableName: $tableName}) {
    recordIds
  }
}
    `;
export const LogoutDocument = gql`
    mutation logout {
  logout(input: {}) {
    success
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    user(variables?: UserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserQuery>(UserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'user');
    },
    masterTableCsv(variables: MasterTableCsvQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MasterTableCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MasterTableCsvQuery>(MasterTableCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'masterTableCsv');
    },
    updateMasterRecord(variables: UpdateMasterRecordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMasterRecordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMasterRecordMutation>(UpdateMasterRecordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMasterRecord');
    },
    masterRecords(variables: MasterRecordsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MasterRecordsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MasterRecordsQuery>(MasterRecordsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'masterRecords');
    },
    createMasterRecord(variables: CreateMasterRecordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateMasterRecordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMasterRecordMutation>(CreateMasterRecordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMasterRecord');
    },
    deleteMasterRecord(variables: DeleteMasterRecordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteMasterRecordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMasterRecordMutation>(DeleteMasterRecordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteMasterRecord');
    },
    deleteMasterTableData(variables: DeleteMasterTableDataMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteMasterTableDataMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMasterTableDataMutation>(DeleteMasterTableDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteMasterTableData');
    },
    finalizeMasterRecord(variables: FinalizeMasterRecordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FinalizeMasterRecordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinalizeMasterRecordMutation>(FinalizeMasterRecordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'finalizeMasterRecord');
    },
    createMasterRecordsCsv(variables: CreateMasterRecordsCsvMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateMasterRecordsCsvMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMasterRecordsCsvMutation>(CreateMasterRecordsCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMasterRecordsCsv');
    },
    masterSchema(variables?: MasterSchemaQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MasterSchemaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MasterSchemaQuery>(MasterSchemaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'masterSchema');
    },
    updateMasterSchema(variables: UpdateMasterSchemaMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMasterSchemaMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMasterSchemaMutation>(UpdateMasterSchemaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMasterSchema');
    },
    finalizeMasterTable(variables: FinalizeMasterTableMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FinalizeMasterTableMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinalizeMasterTableMutation>(FinalizeMasterTableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'finalizeMasterTable');
    },
    rejectMasterTable(variables: RejectMasterTableMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RejectMasterTableMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RejectMasterTableMutation>(RejectMasterTableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rejectMasterTable');
    },
    logout(variables?: LogoutMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LogoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LogoutMutation>(LogoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'logout');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;